/**
 * Says so when a view is showing less than the server matched.
 *
 * Every list is fetched at the API's maximum page size, so a collection that
 * outgrows the cap is shown in part. The gap is named rather than hidden: a
 * page that looks complete is the failure mode, because nothing distinguishes
 * it from one.
 *
 * The filters are no longer part of that caveat. They are sent to the API, so
 * `total` is the size of the whole match and the shortfall is only ever the
 * page cap — earlier this notice had to warn that filtering searched the
 * fetched page alone, which made every narrowed count quietly untrustworthy.
 */
export function TruncationNotice({ shown, total, noun }: { shown: number; total: number; noun: string }) {
  if (shown >= total) return null;
  return (
    <div className="truncation-notice" role="status">
      Showing the first <strong>{shown}</strong> of <strong>{total}</strong> matching {noun}. Narrow the filters to see the rest.
    </div>
  );
}
